export class ScrollReveal {
  constructor() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
  }

  observe(root) {
    root.querySelectorAll(".reveal").forEach((el) => this.observer.observe(el));
  }
}
